export const DELFOS_ADMIN_EMAIL = 'admin@institutodelfos.life';

export const isDelfosAdmin = user =>
  user?.email?.trim().toLowerCase() === DELFOS_ADMIN_EMAIL;

export const getDelfosVisibleLabels = labels =>
  Array.isArray(labels) ? labels : [];
